"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var theme_1 = require("../theme");

function LoadBalancer(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      className = _a.className,
      style = _a.style;
  var text = theme_1.useTextColor(className);
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: size,
    height: size,
    className: text,
    style: style
  }, react_1.default.createElement("path", {
    className: "fill-current",
    d: "M17 12h-6v4h1v4H8v-4h1v-4H3v4h1v4H0v-4h1v-4a2 2 0 012-2h6V6H7V0h6v6h-2v4h6a2 2 0 012 2v4h1v4h-4v-4h1v-4z"
  }));
}

exports.LoadBalancer = LoadBalancer;